var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/why-did-you-update/~/lodash/_Symbol.js
// module id = 296
// module chunks = 0